import { createFileRoute } from '@tanstack/react-router';
import EventBlueprint from 'src/pages/Organization/Event/Blueprints';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/blueprints/$',
)({
  component: EventBlueprint,
});
